const { icons } = require('./constant');

const indus = {
	id: 'indus_master',
	title: 'Indus',
	type: 'collapse',
	icon: icons.IconBranch,
	children: [
		{
			id: 'api_status',
			title: 'API Statuses',
			type: 'item',
			url: '/apiStatuses',
			icon: icons.AccountBalanceOutlinedIcon,
			breadcrumbs: true,
		},
		{
			id: 'indus_validation_messages',
			title: 'Indus Validation Messages',
			type: 'item',
			url: '/indusValidationMessages',
			icon: icons.AccountBalanceOutlinedIcon,
			breadcrumbs: true,
		},
		{
			id: 'indusCityStates',
			title: 'City States Mapping',
			type: 'item',
			url: '/indusCityStates',
			icon: icons.AccountBalanceOutlinedIcon,
			breadcrumbs: true,
		},
	],
};

export default indus;
